import { useDispatch } from "react-redux";

import type { AdminDispatch } from "@/apps/admin/configurations/store";

// The store's dispatch, which takes thunks (signout) as well as actions.
export const useAdminDispatch: () => AdminDispatch = useDispatch;
